export default "__VITE_ASSET__338c0e77__"